import { connect } from 'react-redux'
import { updateElement, editElement, removeElement, clearForm  } from '../../../../actions/elements_order'

function mapStateToProps (state) {
  return {
    elements: Object.values(state.elementsOrder?.elements || {}),
    total: state.elementsOrder?.total,
    removed: state.elementsOrder?.removed || [],
  }
}

function mapDispatchToProps (dispatch) {
  return {
    updateElement: (finderKey, finderValue, field, value) => dispatch(updateElement(finderKey, finderValue, field, value)),
    editElement: element => dispatch(editElement(element)),
    removeElement: (finderKey, finderValue) => dispatch(removeElement(finderKey, finderValue)),
    clearForm: () => dispatch(clearForm()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
